import { groupsListWidgetSettingsParams } from 'settings/groups-list-widget';

export default groupsListWidgetSettingsParams;
